<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  footnotes: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10 col-1200-8">
      <h2
        class="equal-base equal-base--tighter equal-base--tighter-bold-uppercase preparation__title"
      >
        {{ props.title }}
      </h2>
      <ul class="preparation__items">
        <li
          v-for="(item, index) in props.items"
          :key="index"
          class="d-flex flex-column"
        >
          <div class="scale-1 scale-1--headline">
            {{ item.name }}
          </div>
          <div class="d-flex d-flex-row flex-wrap info">
            <div
              v-for="(info, index2) in item.info"
              :key="index2"
            >
              <span
                class="info__text equal-base equal-base--tighter"
              >{{ info }}</span>
              <sup
                v-if="index2 === item.info.length - 1"
                class="info__footnote"
              >
                {{ item.footnote }}
              </sup>
            </div>
          </div>
        </li>
      </ul>
      <ul
        v-if="props.footnotes"
        class="preparation__footnotes"
      >
        <li
          v-for="(footnote, index) in props.footnotes"
          :key="index"
        >
          <span class="equal-small-1">{{ index + 1 }} {{ footnote }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';

.preparation {
  &__title {
    color: $color-disabled;
    margin-bottom: 20px;
  }

  &__items {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      padding: 20px 0;
      border-top: 1px solid $color-dark-01;

      &:last-child {
        border-bottom: 1px solid $color-dark-01;
      }
    }
  }

  &__footnotes {
    list-style: none;
    padding: 0;
    margin: 35px 0 0 0;

    li {
      &:not(:last-child) {
        margin-bottom: 25px;
      }

      span {
        color: $color-plain-grey-60;
        margin-right: 5px;
      }
    }
  }
}

.info {
  margin-top: 5px;
  div:not(:last-child) {
    margin-right: 30px;
  }

  &__footnote {
    margin-left: 5px;
    color: #999999;
  }
  &__text {
    color: $color-light;
  }
}
</style>
